var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canNavigate)?_c('router-link',{staticClass:"company-link",class:{ 'company-link-inherit': _vm.inheritColor },attrs:{"to":{
    name: 'CompanyDetails',
    params: { companyUUID: String(_vm.companyUUID) },
  }},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.companyName))]})],2):_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.companyName))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }